import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button 
      onClick={toggleTheme} 
      className={`btn btn-circle btn-ghost ${className}`}
      aria-label={`Switch to ${theme === 'light' ? 'night' : 'light'} mode`}
    >
      <SunIcon className="h-5 w-5 hidden dark:block" />
      <MoonIcon className="h-5 w-5 block dark:hidden" />
    </button>
  );
};

export default ThemeToggle; 